import React from "react"
import mq from "../components/defaults/styles/mediaquerys"
import { css } from "@emotion/react"
import TruncateMarkup from "react-truncate-markup"
import { color } from "../components/defaults/styles/theme"
import Link from "../components/link"
import { ExpCardSquareInner } from "../components/main/expcard"
import Play from "../components/defaults/assets/svg/play.svg"
import { getImage } from "gatsby-plugin-image"
import { convertToBgImage } from "gbimage-bridge" // temporary fix until gatsby-background-image is fully compatible with the gatsby-plugin-image process
import BackgroundImage from "gatsby-background-image-es5"
import moment from "moment"
import Lock from "../components/defaults/assets/svg/lock.svg"
import LockOpen from "../components/defaults/assets/svg/lock_open.svg"
import { isLoggedIn } from "../services/auth"
import Flags from "../data/raw/flags"
import recordFilter from "./defaults/filters/record"
import rearviewSorting from "./defaults/sorting/rearviewSorting"

export const RvCardList = ({ className, children }) => {
  return (
    <ul
      className={className}
      css={[
        css`
          list-style: none;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          padding: 0;
          margin: 0;
          padding-top: 5rem;
        `,
      ]}
    >
      {children}
    </ul>
  )
}

export const RvCardListItem = ({ children, ...props }) => {
  return (
    <li
      css={css`
        flex: 0 0 100%;
        margin-bottom: ${props.placeholder ? "0" : "4rem"};
        min-width: 0;
        ${mq[0]} {
          flex: 0 0 calc(100% / 2 - 0.55em);
        }
        ${mq[1]} {
          flex: 0 0 calc(100% / 2 - 0.75em);
        }
        ${mq[2]} {
          flex: 0 0 calc(100% / ${props.narrow ? "2" : "3"} - 1em);
        }
        ${mq[3]} {
          flex: 0 0 calc(100% / ${props.narrow ? "2" : "4"} - 1.5em);
        }
      `}
    >
      {children}
    </li>
  )
}

export const RvCardLinkWrapper = ({
  children,
  className,
  recordId,
  password_protected,
}) => {
  return (
    <Link
      to={
        password_protected
          ? `/${Flags.settings.protectedArea.url}/rearview/${recordFilter(
              recordId
            )}`
          : `/rearview/${recordFilter(recordId)}`
      }
      className={className}
      css={css`
        text-decoration: none;
      `}
    >
      {children}
    </Link>
  )
}

export const RvCard = ({ children, className }) => {
  return (
    <div
      className={className}
      css={css`
        position: relative;
      `}
    >
      {children}
    </div>
  )
}

export const RvCardMediaContainer = ({ children, password_protected }) => {
  return (
    <div
      css={css`
        width: 100%;
        position: relative;
        background: ${color.main_dark};
        border-radius: 5px;
        overflow: hidden;
        padding-bottom: 56.25%;
      `}
    >
      <>
        {password_protected ? (
          <div
            css={css`
              position: absolute;
              z-index: 1;
              background: white;
              border-radius: 2rem;
              width: 2em;
              height: 2em;
              top: 0.75em;
              right: 0.75em;
              display: flex;
              align-items: center;
              justify-content: center;
              svg {
                height: 1em;
                width: auto;
                margin-bottom: 0.15em;
              }
            `}
          >
            {isLoggedIn() ? <LockOpen /> : <Lock />}
          </div>
        ) : (
          ""
        )}
        {children}
      </>
    </div>
  )
}

export const RvCardThumbnail = ({ img, children }) => {
  const bgImage =
    img && img.length > 0 ? convertToBgImage(getImage(img[0])) : null
  return (
    <BackgroundImage
      {...bgImage}
      style={{ position: "absolute" }}
      css={css`
        width: 100%;
        height: 100%;
      `}
    >
      {children}
    </BackgroundImage>
  )
}

export const RvCardInfo = ({ title, release, tags, teaser }) => {
  return (
    <div
      css={css`
        margin: 0.75em 0.5em 0;
      `}
    >
      <TruncateMarkup
        lines={1}
        ellipsis={
          <p
            css={css`
              color: ${color.main_dark};
              margin-left: 0.5em;
              display: inline;
              font-size: 0.5em;
              letter-spacing: 0.06em;
              text-transform: uppercase;
              font-weight: 600;
            `}
          >
            ...and more
          </p>
        }
      >
        <div
          css={css`
            margin-bottom: 0.5em;
          `}
        >
          {tags.sort().map((el, index) => (
            <p
              key={index}
              css={css`
                background: ${color.main_dark};
                border-radius: 3px;
                display: inline;
                white-space: nowrap;
                line-height: 1em;
                margin: 0.2em 0.25em;
                padding: 0.5em 0.75em;
                text-transform: uppercase;
                font-weight: 600;
                letter-spacing: 0.06em;
                font-size: 0.5em;
                color: white;
                &:first-of-type {
                  margin-left: 0;
                }
              `}
            >
              {el}
            </p>
          ))}
        </div>
      </TruncateMarkup>
      <TruncateMarkup lines={2}>
        <h3
          css={css`
            font-size: 0.85em;
            line-height: 1.25em;
            font-weight: 600;
            color: ${color.main_dark};
            margin-bottom: 0.5em;
          `}
        >
          {title}
        </h3>
      </TruncateMarkup>
      {teaser ? (
        <div
          css={css`
            margin-bottom: 0.5em;
          `}
        >
          <TruncateMarkup lines={2}>
            <p
              css={css`
                color: ${color.main_dark};
                font-size: 0.65em;
              `}
            >
              {teaser}
            </p>
          </TruncateMarkup>
        </div>
      ) : (
        ""
      )}
      {release ? (
        <div>
          <p
            css={css`
              color: ${color.main_dark};
              font-size: 0.65em;
              letter-spacing: 0.04em;
              opacity: 0.5;
            `}
          >
            {release.date} • {release.time}
          </p>
        </div>
      ) : (
        ""
      )}
    </div>
  )
}

export const RvHandler = ({ data, ...props }) => {
  return rearviewSorting(data).map((node, index) => (
    <RvElement data={node} key={index} {...props} />
  ))
}

export const RvElement = ({ data, ...props }) => {
  // parsing the date (taken from the agenda element to display in moments – days ago since…)
  const getDateFromAgenda = agenda => {
    if (agenda && typeof agenda === "string") {
      return agenda
    } else if (agenda) {
      return agenda[0].data.agenda_start_time
    } else {
      return null
    }
  }

  const parseReleaseDate = data => {
    let releasedate = {}
    if (data && data !== undefined && data !== null) {
      let date = moment(getDateFromAgenda(data)).local().fromNow()
      let time = moment(getDateFromAgenda(data)).local().format("h:mm A")

      releasedate.date = date
      releasedate.time = time
    } else {
      releasedate.date = null
      releasedate.time = null
    }

    return releasedate
  }

  const parseTeaser = data => {
    let startups = data.rearview_startups
    let partners = data.rearview_partners
    let description = data.rearview_description
    let tags = data.rearview_tags

    if (tags.includes("pilot videos") && (!!partners || !!startups)) {
      let participants = []
      if (startups && startups !== undefined && startups !== null) {
        let startupArray = []
        startups.forEach(startup => {
          startupArray.push(startup.data.startup)
        })
        participants = participants.concat(startupArray.sort())
      }
      if (partners && partners !== undefined && partners !== null) {
        let partnerArray = []
        partners.forEach(partner => {
          partnerArray.push(partner.data.name)
        })
        participants = participants.concat(partnerArray.sort())
      }
      return "by " + participants.join(", ")
    } else if (
      description &&
      description !== undefined &&
      description !== null
    ) {
      return description.childMarkdownRemark.excerpt
    } else {
      return null
    }
  }

  return (
    <RvCardListItem narrow={props.narrow}>
      <RvCardLinkWrapper
        recordId={data.recordId}
        password_protected={data.data.password_protected}
      >
        <RvCard>
          <RvCardMediaContainer
            password_protected={data.data.password_protected}
          >
            {data.data.rearview_thumbnail ? (
              <RvCardThumbnail img={data.data.rearview_thumbnail.localFiles}>
                <ExpCardSquareInner
                  css={css`
                    background: linear-gradient(
                      to bottom,
                      hsla(0, 0%, 0%, 0.12) 0%,
                      hsla(0, 0%, 0%, 0.126) 8.2%,
                      hsla(0, 0%, 0%, 0.138) 15.7%,
                      hsla(0, 0%, 0%, 0.156) 22.5%,
                      hsla(0, 0%, 0%, 0.178) 28.8%,
                      hsla(0, 0%, 0%, 0.205) 34.8%,
                      hsla(0, 0%, 0%, 0.233) 40.5%,
                      hsla(0, 0%, 0%, 0.263) 46.1%,
                      hsla(0, 0%, 0%, 0.294) 51.7%,
                      hsla(0, 0%, 0%, 0.324) 57.3%,
                      hsla(0, 0%, 0%, 0.352) 63.2%,
                      hsla(0, 0%, 0%, 0.377) 69.4%,
                      hsla(0, 0%, 0%, 0.399) 76.1%,
                      hsla(0, 0%, 0%, 0.415) 83.3%,
                      hsla(0, 0%, 0%, 0.426) 91.2%,
                      hsla(0, 0%, 0%, 0.43) 100%
                    );
                    padding: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  `}
                >
                  <Play
                    css={css`
                      stroke: white;
                      width: 2em;
                      height: auto;
                    `}
                  />
                </ExpCardSquareInner>
              </RvCardThumbnail>
            ) : (
              ""
            )}
          </RvCardMediaContainer>
          <RvCardInfo
            title={data.data.rearview_title}
            release={
              data.data.rearview_release
                ? parseReleaseDate(data.data.rearview_release)
                : data.data.rearview_agenda &&
                  data.data.rearview_agenda.length > 0 &&
                  data.data.rearview_agenda[0].data.agenda_start_time
                ? parseReleaseDate(data.data.rearview_agenda)
                : null
            }
            tags={data.data.rearview_tags}
            teaser={parseTeaser(data.data)}
          />
        </RvCard>
      </RvCardLinkWrapper>
    </RvCardListItem>
  )
}
